module.exports = __webpack_public_path__ + "img/logo.c6f9af07.svg";